export   const translate  = (lang , query )=>{
  return (id , all = false )=>{
    return all? query?.[id]   :  query?.[id]?.[lang];
  }
}
